import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../../Login/components/layout";
import LoginPage from "../../components/login";
import GuestRoute from "../../components/GuestRoute";

const LoginContainer = () => (
  <GuestRoute>
    <main>
      <Helmet title="Login" />
      <Layout>
        <LoginPage />
      </Layout>
    </main>
  </GuestRoute>
);

export default LoginContainer;
